module.exports = __webpack_public_path__ + "static/media/logo.f1d64ca2.png";